import { render, staticRenderFns } from "./PointersOfTheMonth.vue?vue&type=template&id=15339c5c&scoped=true"
import script from "./PointersOfTheMonth.vue?vue&type=script&lang=js"
export * from "./PointersOfTheMonth.vue?vue&type=script&lang=js"
import style0 from "./PointersOfTheMonth.vue?vue&type=style&index=0&id=15339c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15339c5c",
  null
  
)

export default component.exports